import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';
import { useTranslation } from 'react-i18next';
import './i18n';

if (localStorage.getItem('cc-theme') === 'dark') document.documentElement.classList.add('dark');

// the whole portal is drawn again when the language changes, so every t('...') call shows the new language
function Root() {
  const { i18n } = useTranslation();
  return <App key={i18n.language} />;
}

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 2000 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Root />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
